export default {
  modalTitleDelete: {
    id: 'bo_seller-profile-user_permission-delete_modal-title',
    defaultMessage: 'Delete user',
  },
  modalTitleActivate: {
    id: 'bo_seller-profile-user_permission-delete_modal-title_activate',
    defaultMessage: 'Re-activate user',
  },
  areYouSureDelete: {
    id: 'bo_seller-profile-user_permission-delete_modal-are_you_sure',
    defaultMessage: 'Are you sure you want to delete this user?',
  },
  areYouSureActivate: {
    id: 'bo_seller-profile-user_permission-delete_modal-are_you_sure_activate',
    defaultMessage: 'Are you sure you want to re-activate this user?',
  },
  yesDelete: {
    id: 'bo_seller-profile-user_permission-delete_modal-yes_delete',
    defaultMessage: 'Yes, delete this user',
  },
  yesActivate: {
    id: 'bo_seller-profile-user_permission-delete_modal-yes_activate',
    defaultMessage: 'Yes, activate this user',
  },
  noKeep: {
    id: 'bo_seller-profile-user_permission-delete_modal-no_keep',
    defaultMessage: 'No, keep this user',
  },
  noActivate: {
    id: 'bo_seller-profile-user_permission-delete_modal-no_activate',
    defaultMessage: 'No, do not re-activate this user',
  },
  userDeleted: {
    id: 'bo_seller-profile-user_permission-delete_modal-user_deleted',
    defaultMessage: 'User has been deleted!',
  },
}
